export function initDynamicPlaceholders() {
    const dynamicPlaceholdersContainer = document.querySelector('.js-dynamicPlaceholders');
    if (!dynamicPlaceholdersContainer || dynamicPlaceholdersContainer.dataset.initialized) return;

    const wrapper = dynamicPlaceholdersContainer.closest('.dynamicPlaceholders__container');
    const dynamicPlaceholders = dynamicPlaceholdersContainer.querySelectorAll('.dynamicPlaceholders__element');
    const searchbar = wrapper?.closest('.searchBar');

    if (!dynamicPlaceholders.length || !wrapper || !searchbar) return;

    dynamicPlaceholdersContainer.dataset.initialized = true;

    let i = 0;
    const interval = 2500;

    setInterval(() => {
        rotatePlaceholder(dynamicPlaceholders[i], interval);
        i = (i + 1) % dynamicPlaceholders.length;
    }, interval);

    wrapper.addEventListener('click', () => {
        wrapper.classList.add('is-hidden');
        searchbar.querySelector('input')?.focus();
    });

    document.addEventListener('click', e => {
        if (!e.target.closest('.dynamicPlaceholders__container')) {
            const input = document.querySelector('input[name="input_search"]');
            if (input?.value === '') {
                wrapper.classList.remove('is-hidden');
            }
        }
    }, { passive: true });
}

function rotatePlaceholder(element, interval) {
    element.classList.add('is-active');

    setTimeout(() => {
        element.classList.add('is-fadingOut');

        setTimeout(() => {
            element.classList.remove('is-active', 'is-fadingOut');
        }, 0.1 * interval);
    }, 0.9 * interval);
}